import { isNil } from '../isNil';
export class CallbackErrorHandlerDecorator {
  handler;
  callback;
  constructor(handler, callback) {
    this.handler = handler;
    this.callback = callback;
  }
  canHandle(error) {
    return this.handler.canHandle(error);
  }
  handleError(error, errorMessages, _callback) {
    const result = this.handler.handleError(error, errorMessages);
    if (this.callback) {
      this.callback();
    }
    return result;
  }
}
export class ServerErrorHandlerFactory {
  DefaultHandler;
  handlers = [];
  constructor(handlers, defaultHandler) {
    if (!Array.isArray(handlers)) {
      throw new Error('Invalid handlers array');
    }
    if (isNil(defaultHandler)) {
      throw new Error('Invalid default handler');
    }
    this.handlers = handlers;
    this.DefaultHandler = defaultHandler;
  }
  getHandler(error) {
    return this.handlers.find(handler => {
      return handler.canHandle(error);
    }) ?? this.DefaultHandler;
  }
}